import * as React from "react";
import { createSimpleFilterConfig, useGenericFiltersWithRenderer } from "../../../../../utils/GenericFilters";
import { PolicyFilters } from "../../../../../store/Policies/Types";
import { ThemePalette } from "@vwpfs/mary-air-lib/theme/_Types";
import { Alignment, ButtonsWrapper, Orientation } from "@vwpfs/mary-air-lib/components/air/06-molecules/ButtonsWrapper";
import { Div } from "@vwpfs/mary-air-lib/components/air/03-base/Div";
import { Grid } from "@vwpfs/mary-air-lib/components/air/03-base/Grid";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { Form } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form";
import { FilterScope } from "../../../../../store/FilterTypes";
import { RemoteScope } from "../../../../../store/RemoteTypes";
import { PolicyFilterFieldsConfig } from "../../../../../store/Policies/Displays";
import { FormField } from "@vwpfs/mary-air-lib/components/air/07-organisms/Form/Field";

interface FilterProps {
    loadingResults: boolean;
    defaultFilters?: PolicyFilters;
}

/**
 * Ultra-simple filter config - everything in one fields object!
 */
const filterConfig = createSimpleFilterConfig<PolicyFilters>({
    filterScope: FilterScope.POLICIES,
    remoteScope: RemoteScope.POLICY_RESULTS,
    fields: PolicyFilterFieldsConfig,
});

export const Filter: React.FC<FilterProps> = ({ loadingResults, defaultFilters }) => {
    const {
        searchEnabled,
        initAndClearFilters,
        onSearchFilter,
        initFilters,
        clearResults,
        getFieldProps,
    } = useGenericFiltersWithRenderer(filterConfig, defaultFilters, loadingResults);

    // Ultra-simple field renderer using the generic system
    const renderField = (fieldKey: keyof PolicyFilters) => {
        const props = getFieldProps(fieldKey);
        return props ? (
            <Grid key={fieldKey} size={{ xs: 12, md: 6 }}>
                <FormField {...props} />
            </Grid>
        ) : null;
    };

    // Initialize filters on mount
    React.useEffect(() => {
        initFilters();
        return clearResults;
    }, []); // Empty dependency array - only run once on mount

    return (
        <Form onSubmit={onSearchFilter}>
            <Div className="scl-b-row">
                {filterConfig.fields.map(field => renderField(field.key))}
            </Div>
            <ButtonsWrapper alignment={Alignment.CENTER} defaultOrientation={Orientation.HORIZONTAL}>
                <Button
                    className="scl-a-btn--big scl-a-btn scl-a-btn--brand-link"
                    link={{ onClick: initAndClearFilters }}
                    disabled={!searchEnabled || loadingResults}
                >
                    Clear filters
                </Button>
                {" "}
                <Button
                    theme={{ palette: ThemePalette.BRAND_ACCENT }}
                    className="scl-a-btn--big"
                    buttonType="submit"
                    disabled={loadingResults}
                >
                    Search
                </Button>
            </ButtonsWrapper>
        </Form>
    );
};
